export default __webpack_public_path__ + "static/premioACL-e422496235fc392fbfcf37babdf1e3c6.png";